// extracted by mini-css-extract-plugin
export default {"title":"styles_title__K1zbh","subtitle":"styles_subtitle__vwfpm","vid":"styles_vid__t2stn","vidContainer":"styles_vidContainer__29luz"};